import { render, staticRenderFns } from "./smallLoading.vue?vue&type=template&id=34491b50&scoped=true&"
import script from "./smallLoading.vue?vue&type=script&lang=js&"
export * from "./smallLoading.vue?vue&type=script&lang=js&"
import style0 from "./smallLoading.vue?vue&type=style&index=0&id=34491b50&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34491b50",
  null
  
)

export default component.exports